import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import "./SideBar.css";

export default function SideBar({ role = "doctor" }) {

  const navigate = useNavigate();
  const location = useLocation();

  /* ================= STYLES ================= */


  const activeClass =
   "flex flex-row items-center gap-3 p-3 rounded-lg cursor-pointer bg-[#cdebfa] text-[#0a1d37] font-bold transition-all border-r-4 border-[#0a1d37] text-[18px]";

  const inactiveClass =
  "flex flex-row items-center gap-3 p-3 rounded-lg cursor-pointer text-white hover:bg-white/10 transition-all border-r-4 border-transparent text-[18px]";
  

  /* ================= DOCTOR LINKS ================= */

  const doctorLinks = [
    {
      label: "الرئيسية",
      path: "/Main",
      icon: "fa-solid fa-house",
      subPaths: [
      "/Main",
      "/patient-profile/" 
    ]
    },
    {
      label: "الملف الشخصي",
      path: "/doctor",
      icon: "fa-solid fa-user"
    },
    {
      label: "الدعم",
      path: "/support",
      icon: "fa-solid fa-headset"
    }
  ];

  /* ================= ADMIN LINKS ================= */

  const adminLinks = [
    {
      label: "الرئيسية",
      path: "/Admin_Main",
      icon: "fa-solid fa-house"
    },
    {
      label: "لوحة التحكم",
      path: "/admin-dashboard",
      icon: "fa-solid fa-chart-line"
    },
    {
      label: "مدير الحسابات",
      path: "/accounts-manager",
      icon: "fa-solid fa-users-gear",
      subPaths: [
      "/accounts-manager",
      "/All-doctors",
      "/doctor"
,     "/all-admins",
      "/admins-profiles",
      "/admin-profile"
    ]
    },
    {
      label: "المرضى",
      path: "/all-patients",
      icon: "fa-solid fa-user-injured",
      subPaths: [
      "/patient-profile"
    ]
    },
    {
      label: "الدعم",
      path: "/support-request",
      icon: "fa-solid fa-headset"
    }
  ];

  /* ================= SELECT LINKS ================= */

  const links = role === "admin" ? adminLinks : doctorLinks;

  /* ================= RENDER ================= */

  return (
    <aside
  dir="rtl"
  className="w-[260px] bg-[#0a1d37] text-white flex flex-col p-6"
>
      

      {/* LOGO */}
      <div className="h-20 mb-6 flex items-center justify-center">
        <img
          className="syria-logo-sidebar-logo"
          src="/images/Emblem_of_Syria_(2025–present).svg.png"
          alt="logo"
        />
      </div>

      {/* LINKS */}
      <nav className="flex flex-col gap-2">

        {links.map((item, index) => {

          const isActive =
          location.pathname === item.path ||
          (item.subPaths &&
          item.subPaths.some(path =>
          location.pathname.startsWith(path)
          ));

          return (
            <div
              key={index}
              onClick={() => navigate(item.path)}
              className={isActive ? activeClass : inactiveClass}
            >
            
              {/* الأيقونة (يمين) */}
              <i className={`${item.icon} text-xl`}></i>

              {/* النص */}
              <span>{item.label}</span>
            </div>
          );
        })}

      </nav>
    </aside>
  );
}